module.exports = __webpack_public_path__ + "img/product-ig.99c7b6a0.svg";